'use strict';

var moduleName = 'filter-fly';

module.exports = function () {
	$('[js-filter-fly]').each(function () {
		if($.data(this, moduleName + '-init')) return;
		$.data(this, moduleName + '-init', true);



		var wrap    = $(this),
			field   = wrap.find('[js-filter-fly-field]'),
			content = wrap.find('[js-filter-fly-content]');

		$(field).on('keyup', function() {
			var textSearch = $(this).val().toLowerCase(),
				match = true;

			content.find('input[type="checkbox"]').each(function() {
				var fieldVal = $(this).siblings('span').text().toLowerCase();


				if(new RegExp(textSearch, 'i').test(fieldVal)) {
					$(this).parent('label').show(200);
					match = false;
				} else {
					$(this).parent('label').hide(200);
				}
			});

			if(match) {
				$('[js-filter-fly-not-found]').show(200);
			} else {
				$('[js-filter-fly-not-found]').hide(200);
			}
		});



		$('[js-reset-filter]').on('click', function() {
			content.find('label').show(200);
			$('[js-filter-fly-not-found]').hide(200);
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/filterFlyInit.js
 **/